import React, { useState, ReactNode } from 'react';
import { Button, ButtonProps, shapes } from '@cimpress/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useModal } from '../../../contexts/modal-context';
import ConfirmDialog from '../ConfirmDialog';

export interface DeleteButtonProps extends ButtonProps {
  onClick: (e: Event) => void;
  children?: ReactNode;
  stopPropagation?: boolean;
}

// tslint:disable-next-line:function-name
export default function DeleteButton({
  onClick,
  children,
  stopPropagation = true,
}: DeleteButtonProps) {
  const modal = useModal();
  const [active, setActive] = useState(false);
  const onConfirm = (e: Event) => {
    setActive(true);
    onClick(e);
  };
  const clickAction = (e: Event) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    if (children) {
      modal(
        'Confirm the action',
        hide => <ConfirmDialog hide={hide} confirm={() => onConfirm(e)}>{children}</ConfirmDialog>,
        { bsStyle: 'warning' },
      );
    } else {
      onConfirm(e);
    }
  };
  return <Button onClick={clickAction} type="link">
    {active &&
      <shapes.Spinner size="small"/> ||
      <FontAwesomeIcon icon={faTrash} color="var(--danger)"/>
    }
  </Button>;
}
